import { useEffect, useState } from 'react';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import { Link, generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

function AppHeaderLogo() {
  const [logoPath, setLogoPath] = useState('/d/dashboard');
  const { businessEntityUuid } = useBusinessEntity();

  useEffect(() => {
    if (businessEntityUuid) {
      setLogoPath(generatePath(ROUTES.company, { businessEntityUuid }));
    }
  }, [businessEntityUuid]);

  return (
    <Link
      aria-label="Return to dashboard"
      tabIndex={0}
      to={logoPath}
    >
      <SharedAsset
        alt="ZenBusiness logo"
        height={48}
        src="/logo/new-circle-logo-teal.svg"
      />
    </Link>
  );
}

export default AppHeaderLogo;
